module.exports = function (bootstrap) {
    bootstrap.directive('siteHeader', ["modal", "navigation", "brand", "services", "session", "$timeout", "$window", "$sce", function (modal, navigation, brand, services, session, $timeout, $window, $sce) {
        return {
            replace: true,
            transclude: true,
            scope: {
                showLanguages: "=",
                extraButton: "="
            },
            link: function (scope, element) {
                var nav = element.find('nav');

                var body = angular.element('body');
                body.on('click', function (evt) {
                    var target = body.find('.headerNeedHelpParent');
                    if (target) {
                        if (!(target.find(evt.target).length > 0)) {
                            scope.showNeedHelp = false;
                            scope.$apply();
                        }
                    }

                    target = body.find('.headerFontSizerParent');
                    if (target) {
                        if (!(target.find(evt.target).length > 0)) {
                            scope.showFontSizer = false;
                            scope.$apply();
                        }
                    }

                    target = body.find('.headerLanguageMenuParent');
                    if (target) {
                        if (!(target.find(evt.target).length > 0)) {
                            scope.showLangMenu = false;
                            scope.$apply();
                        }
                    }

                    target = body.find('.loginBox');
                    if (target) {
                        if (!(target.find(evt.target).length > 0)) {
                            scope.showLoginBox = false;
                            scope.$apply();
                        }
                    }

                    target = body.find('.yourAccountMenu');
                    var buttonTarget = body.find('.yourAccountButton');

                    if (target && buttonTarget) {
                        if (!angular.element(evt.target).closest(target).length && !angular.element(evt.target).closest(buttonTarget).length) {
                            scope.extraOpen = false;
                            scope.$apply();
                        }
                    }
                });

                body.on('keydown', function (evt) {
                    if (evt.which === 9 || evt.keyCode === 9) {
                        $timeout(function () {
                            var target = body.find(':focus');

                            hideHeaderMenuItemIfTabbingOut(target, ['.headerNeedHelpParent'], 'showNeedHelp');
                            hideHeaderMenuItemIfTabbingOut(target, ['.headerFontSizerParent'], 'showFontSizer');
                            hideHeaderMenuItemIfTabbingOut(target, ['.headerLanguageMenuParent'], 'showLangMenu');
                            hideHeaderMenuItemIfTabbingOut(target, ['.loginBox'], 'showLoginBox');
                            hideHeaderMenuItemIfTabbingOut(target, ['.yourAccountMenu', '.yourAccountButton'], 'extraOpen');

                            scope.$apply();
                        });
                    }
                });

                function hideHeaderMenuItemIfTabbingOut(target, menuParentClasses, menuBoolean) {
                    var i = 0,
                        nonHighlightedElementCount = 0;

                    if (scope[menuBoolean]) { //if dropdown is open
                        for (i; i < menuParentClasses.length; i++) {
                            if (!target.closest(menuParentClasses[i]).length) {
                                nonHighlightedElementCount++;
                            }
                        }
                        if (nonHighlightedElementCount === menuParentClasses.length) { //if dropdown is open but no related elements are highlighted, close dropdown.
                            scope[menuBoolean] = false;
                        }
                    }

                }

                scope.openCloseTouch = function () {
                    if (!nav.hasClass('ng-animate')) {
                        scope.navopen = !scope.navopen;
                    }
                };
            },
            controller: 'headerController',
            template: require('./header.html')
        };
    }]);
    bootstrap.controller('headerController', [
        "$scope", "$q", "$window", "coremetrics", "teamsite", "$sce", "$document", "sessionData", "invisibleForm", "clickToChat", "modal", "navigation", "brand", "appConfig", "services", "session", "$timeout", "$state", "$cookies", "coremetricsConversionTracker", "taglines", "appId", "$location", "hook", "$anchorScroll", "smoothFocus", "$window",
        function ($scope, $q, $window, coremetrics, teamsite, $sce, $document, sessionData, invisibleForm, clickToChat, modal, navigation, brand, appConfig, services, session, $timeout, $state, $cookies, coremetricsConversionTracker, taglines, appId, $location, hook, $anchorScroll, smoothFocus, $window) {

            var REGIONAL_LANGUAGES_CONTENT_ID = 'REGIONAL_LANGUAGES',
                MBR_MEANINGFUL_ACCESS_LINK_ID = 'MBR_MEANINGFUL_ACCESS_LINK';
            var MBR_MEANINGFUL_ACCESS_LINK_BTS3_NDMEDICAID_ID ='MBR_MEANINGFUL_ACCESS_LINK_BTS3_NDMEDICAID';

            var needHelpCoremtricsFlag = false;
            // Get Languages content for taglines.
            var allLanguages = {};
            taglines.getAllLanguages().then(
                function (response) {
                    allLanguages = response;
                }, function () {
                }
            );

            $scope.showClickToChat = false;

            appConfig.getAll().then(function (appConfigResponse) {
                sessionData.appConfig = angular.extend({}, appConfigResponse);

                if($cookies.get('LtpaToken2')) {
                    teamsite.get("CHAT_HIDE_CLIENT_LIST").then(function (response) {
                        var suppressClientList = response;

                        if (sessionData.appConfig &&
                            sessionData.appConfig.MEMBER &&
                            sessionData.appConfig.MEMBER.USE_AVAYA_INDICATOR &&
                            sessionData.appConfig.MEMBER.USE_AVAYA_INDICATOR.booleanValue == false &&
                            sessionData.appConfig.MEMBER.MBR_SHOW_AVAYA_CHAT &&
                            sessionData.appConfig.MEMBER.MBR_SHOW_AVAYA_CHAT.booleanValue &&
                            $cookies.get('emkt_ctc') === 'Y' &&
                            $cookies.get('mbrClientNumber').indexOf(suppressClientList) === -1) {
                            $scope.toggle = "live";
                            $scope.showClickToChat = true;
                        }
                    });
                } else{
                    $scope.toggle ="pre";
                    $scope.preLoginChat = sessionData.appConfig &&
                        sessionData.appConfig.MEMBER &&  sessionData.appConfig.MEMBER.MBR_SHOW_PRE_AVAYA_CHAT &&
                        sessionData.appConfig.MEMBER.MBR_SHOW_PRE_AVAYA_CHAT.booleanValue;
                }


                $scope.disableNavTabs = sessionData.appConfig.PROVIDER &&
                    sessionData.appConfig.PROVIDER.PVD_HIDE_NAV_TABS &&
                    sessionData.appConfig.PROVIDER.PVD_HIDE_NAV_TABS.booleanValue;
                $scope.isVitalsActive = sessionData.appConfig.FIND_A_DOCTOR &&
                    sessionData.appConfig.FIND_A_DOCTOR.VITALS_LIVE &&
                    sessionData.appConfig.FIND_A_DOCTOR.VITALS_LIVE.booleanValue;
                $scope.isVitalsActive = $scope.isVitalsActive && brand.current.isVitalsActive;

                $scope.OauthMBH = sessionData.appConfig.ACCOUNT_SETTINGS &&
                    sessionData.appConfig.ACCOUNT_SETTINGS.MFA_ENROLL_ELIGIBLE &&
                    sessionData.appConfig.ACCOUNT_SETTINGS.MFA_ENROLL_ELIGIBLE.booleanValue == true;
            });

            $scope.switchExtraOpen = function () {
                $scope.extraOpen = !$scope.extraOpen;
            };

            $scope.switchLoginBox = function () {
                $scope.showMobileLoginBox = !$scope.showMobileLoginBox;
                $timeout(function () {
                    document.activeElement.blur();
                    smoothFocus.clearTab();
                    smoothFocus.setTab(document.activeElement);
                }, 0);
            };

            var body = angular.element('body');
            body.on('click', function (evt) {

                var target = body.find('.headerLoginBox');
                var buttonTarget = body.find('.login-button');
                var buttonCheck = buttonTarget[0] && buttonTarget[0].className == evt.target.className ? [1] : [] || buttonTarget.find(evt.target);
                var targetCheck = target.find(evt.target);

                if (target && buttonTarget) {
                    if (!(targetCheck.length > 0 || buttonCheck.length > 0)) {
                        $scope.showMobileLoginBox = false;
                        $scope.$apply();
                    }
                }

                target = body.find('.yourAccountMenu');
                buttonTarget = body.find('.yourAccountButton');
                buttonCheck = (buttonTarget[0] == evt.target || buttonTarget == evt.target) ? [1] : buttonTarget.find(evt.target);
                targetCheck = target.find(evt.target);

                if (target && buttonTarget) {
                    if (!(targetCheck.length > 0 || buttonCheck.length > 0) || (!angular.element(evt.target).closest(target).length && !angular.element(evt.target).closest(buttonTarget).length)) {
                        $scope.extraOpen = false;
                        $scope.$apply();
                    }
                }

                target = body.find('.headerNeedHelpParent');
                if (target) {
                    if (!(target.find(evt.target).length > 0)) {
                        $scope.showNeedHelp = false;
                        $scope.$apply();
                    }
                }

                target = body.find('.headerFontSizerParent');
                if (target) {
                    if (!(target.find(evt.target).length > 0)) {
                        $scope.showFontSizer = false;
                        $scope.$apply();
                    }
                }

                target = body.find('.headerLanguageMenuParent');
                if (target) {
                    if (!(target.find(evt.target).length > 0)) {
                        $scope.showLangMenu = false;
                        $scope.$apply();
                    }
                }
            });

            // Set up scope variables for languages and meaningful-access link.
            $scope.languages = [];
            $scope.meaningfulAccessURL = null;

            $scope.showLangMenu = false;
            $scope.showFontSizer = false;
            $scope.showNeedHelp = false;
            $scope.showLoginBox = false;

            if ($location.search().returnTo === '/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/GUIDEWELLMEMBER') {
                $scope.guideWellShowLogin = false;
            } else if ($location.search().returnTo === '/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/WEBMDND?StartID=87') {
                $scope.webMDShowLogin = false;
            } else {
                $scope.guideWellShowLogin = true;
                $scope.webMDShowLogin = true;
            }
            ;


            $scope.loginInfo = {
                username: "",
                password: "",
                rememberUserName: false
            };
            /*Hardcode Values for wy/nd*/
            $scope.isMINCR = brand.current.ubk === 6010;
            $scope.isNDBCBS = brand.current.ubk === 6011;
            $scope.isWYBCBS = brand.current.ubk === 6012;
            $scope.isWYBCBSSNR = $scope.isWYBCBS && appId.toLowerCase() === 'medweb';

            var wyShopUrlRegex = /shop([dt]env([0-9]|[abcdet]))?\.yourwyoblue\.com/;
            //compare the webhost against the regex
            $scope.isWyShop = wyShopUrlRegex.test(window.location.host);
            $scope.translationServices = "https://www.bcbswy.com/docs/Translation_NonDiscrimination.pdf";
            $scope.ndLanguageAssistance = "https://www.bcbsnd.com/content/dam/bcbsnd/documents/non-discrimination-notice/Non-Discrimination-Notice-Language-and-Disability-Access-Assistance.pdf";

            var hmShopUrlRegex = /shop([dt]env([0-9]|[abcdet]))?\.highmark\.com/;
            $scope.isHmShop = hmShopUrlRegex.test(window.location.host);
            if ($scope.isHmShop) {
                hook.register("toggleChatAvailabilityOn", function () {
                    $scope.disableClickToChat = false;
                });
                hook.register("toggleChatAvailabilityOff", function () {
                    $scope.disableClickToChat = true;
                });
                $scope.$watch(function () {
                    return brand.current.sharedBrandCode;
                }, function (newValue, oldValue) {
                    //if in HM domain on shop site
                    //retrieve Branded/general content from the CMS tool
                    var acaConfig = false;
                    teamsite.get("HMSHOP_NEED_HELP_CONTENT").then(function (data) {
                        var curBrand = brand.current.sharedBrandCode.toLowerCase();
                        try {
                            var teamsiteData = JSON.parse(data);
                            teamsite.get("HMSHOP_NEED_HELP_CONTENT_ACACONFIG").then(function (acConfig) {
                                var dat = JSON.parse(acConfig);
                                acaConfig = dat.DEFAULT.ACALive;
                                $scope.hmChatBlockHead = acaConfig ? teamsiteData.chatBlock.chatHeaderACA : teamsiteData.chatBlock.chatHeader;

                            });
                            $scope.hmCallBlock = teamsiteData.callBlock[curBrand];
                            $scope.hmStoreBlock = teamsiteData.storeBlock;
                            var requestTemp = teamsiteData.requestBlock.html.replace("link", "https://" + window.location.host + teamsiteData.requestBlock.link);
                            $scope.hmRequestBlock = requestTemp;
                            $scope.hmChatBlockHead = teamsiteData.chatBlock.chatHeaderACA;
                            $scope.hmChatBlockLink = teamsiteData.chatBlock.chatLinkText;
                            $scope.hmChatBlockFoot = teamsiteData.chatBlock.chatFooter;
                        } catch (exception) {
                            console.log(exception);
                        }
                    });
                });
            }

            if (appId.toLowerCase() === 'medweb') {
                $scope.CSPhoneNumber = '<br><br>1-866-856-6166<br>Or<br>The number on the back of your member ID card<br>8:00 AM - 8:00 PM<br>7 days/week<br>TTY: Dial 711';
            }

            $scope.shouldShowLanguagesHeader = false;
            var populateHeaderLanguagesMenu = function () {
                var tagalog = {
                    'languageCode': 'tl',
                    'languageName': 'Tagalog',
                    'isRTL': false,
                    'nativeName': 'Tagalog'
                };

                // Set up $scope.languages based off of teamsite.
                teamsite.get(REGIONAL_LANGUAGES_CONTENT_ID).then(
                    function (response) {
                        var regionalLanguages = JSON.parse(response);
                        // For each langugage code in the languages property, ...
                        angular.forEach(regionalLanguages.languages, function (item) {
                            // ...if the language code is in allLanguages, ...
                            if (allLanguages[item]) {
                                // ...push the language information from allLanguages into $scope.languages.
                                if ($scope.isWYBCBS && item === 'tl') {
                                    $scope.languages.push(tagalog);
                                } else {
                                    $scope.languages.push(allLanguages[item]);
                                }
                            }
                        });
                    }, function (/*error*/) {
                    }
                );

            };
            //Login link to OAM auth endpoint
            $scope.oAuthMfaRedirect = function(){

                var environmentConfigs =
                {
                    highmarkbcbs:{
                        test: {
                            environmentType: 'test.auth',
                            client_id: '526f617-04d5-64b5-84a637376414845716c44304755673d3d'

                        },
                        prod: {
                            environmentType: 'auth',
                            client_id: '64302b7-7724-2736-4737239755430515a2f61596e6a413d3d'
                        },
                        domain:'legacy-portal-apps-domain'

                    },
                    highmarkbcbswv:{
                        test: {
                            environmentType: 'test.auth',
                            client_id: '4e52355-96a5-8304-462456e435569577a6971414633673d3d'

                        },
                        prod: {
                            environmentType: 'auth',
                            client_id: '71774c4-54d7-a4c7-341726556344b44416549424f79773d3d'
                        },
                        domain:'legacy-portal-apps-domain'

                    },
                    highmarkbcbsde:{
                        test: {
                            environmentType: 'test.auth',
                            client_id: '69326d6-8496-2726-c57726271676b74745a4b6f3975673d3d'

                        },
                        prod: {
                            environmentType: 'auth',
                            client_id: '5463576-76e7-8417-26b307a59797949553179563374773d3d'
                        },
                        domain:'legacy-portal-apps-domain'

                    },
                    highmarkblueshield:{
                        test: {
                            environmentType: 'test.auth',
                            client_id: '4d704e6-b435-86c6-e495849576e4f335a496d345976413d3d'

                        },
                        prod: {
                            environmentType: 'auth',
                            client_id: '4533796-b4e3-4437-5596861317445544738444f4137773d3d'
                        },
                        domain:'legacy-portal-apps-domain'

                    },
                    mybenefitshome:{
                        test:{
                            environmentType:"https://test.auth.allmyhealth.com/oauth2/rest/authz?",
                            client_id:"39597a4-4426-a2b4-f4c693846585557786c37533164773d3d"
                        },
                        prod: {
                            environmentType: "https://auth.allmyhealth.com/oauth2/rest/authz?",
                            client_id: "466f623-0544-44b6-3565242546e4262544439694162413d3d"
                        },
                        domain:'allmyhealth'
                    },
                    bcbsndportals:{
                        test:{
                            environmentType:"https://test.auth.bcbsndportals.com/oauth2/rest/authz?",
                            client_id:"6675704-72f4-f357-74a354959467a41384457373945413d3d"
                        },
                        prod: {
                            environmentType: "https://auth.bcbsndportals.com/oauth2/rest/authz?",
                            client_id: '7276743-1743-6564-a773445476e6e336449796d6741413d3d'
                        },
                        domain:'MemberND'
                    },
                    yourwyoblue:{
                        test:{
                            environmentType:"https://test.auth.yourwyoblue.com/oauth2/rest/authz?",
                            client_id:"31736a3-6616-f543-97241454a722b45706e4a397758773d3d"
                        },
                        prod: {
                            environmentType: "https://auth.yourwyoblue.com/oauth2/rest/authz?",
                            client_id: '6465306-1557-8757-a446e47732f4665794b30502f51513d3d'
                        },
                        domain:'MemberWY'
                    }

                };


                var hostnameArray = window.location.hostname.split('.'),
                    subDomain = hostnameArray[0],
                    brandDomain= hostnameArray[1],
                    currentConfig ={};



                if (subDomain == 'www' || subDomain == 'penv'){
                    currentConfig = environmentConfigs[brandDomain].prod;

                }else{
                    currentConfig = environmentConfigs[brandDomain].test;

                }
                var
                    oamAuthorizeRoot = brandDomain=="mybenefitshome" || brandDomain=="bcbsndportals" || brandDomain=="yourwyoblue"? currentConfig.environmentType:'https://'+currentConfig.environmentType+".highmark.com/oauth2/rest/authz?",
                    redirectUri = "https://"+window.location.hostname+"/login/#/loggingIn",

                    params = [
                        "response_type=code",
                        "client_id=" + currentConfig.client_id,
                        "scope=resource.READ",
                        "domain="+ environmentConfigs[brandDomain].domain,
                        "redirect_uri=" + encodeURIComponent(redirectUri)
                    ];
                window.location.href = oamAuthorizeRoot + params.join('&');



            };
            var oauthLoginModal =function(){

                        modal.open({
                            scope:$scope,
                            template:'<h3>New secure login experience</h3>'+
                            '<hr class="thick" />'+
                            '<div id="oauth-login-redirect" class="loginOauthRedirect">'+
                            '<div >'+
                            '<p>By clicking "CONTINUE" below, you will be redirected to a new login page.</p>'+
                            '<p>If you are a user who has enrolled in Multi-Factor Authentication, you will be required to enter the passcode sent to your mobile phone or email.</p>'+
                            '</div>'+
                            '<div class="buttonDiv">'+
                            '<button id="oauthRedirect" data-ng-click="oAuthMfaRedirect()" class="action-btn float-r close">Continue</button></div>'+
                            '</div>'

                        });

                };


            $scope.logInButton = function () {
                switch (brand.current.sharedBrandCode) {
                    case "hmbcbs":
                    case "highmarkbcbs":
                    case "hbcbs":
                    case "hbs":
                    case "highmarkblueshield":
                    case "hmbcbsde":
                    case "highmarkbcbsde":
                    case "de":
                    case "ms":
                    case "highmarkbcbswv":
                    case "hmbcbswv":
                        oauthLoginModal();

                        break;
                    case "mincr":
                        var env = window.location.host.split(".")[0]; 
                        window.location="https://www"+(env === 'www' ? "" : ".qa")+".bluecrossmn.com/member-login";
                        break;
                    case "pp":
                        if ($scope.OauthMBH){
                            oauthLoginModal();
                            break;
                        }
                      
                    default:
                        $scope.showLoginBox = !$scope.showLoginBox;
                        coremetrics.pageviewTag('LOGIN', 'LOGIN');
                        coremetricsConversionTracker.start('LOGIN', 'LOGIN');
                        break;}


            };
            hook.register("triggerLoginBox", function () {
                $timeout(function () {
                    $scope.logInButton();
                    $anchorScroll();
                }, 0);
            });

            $scope.closeLanguagesMenu = function () {


                $scope.showLangMenu = false;
            };

            $scope.logout = function () {
                // fix for CHMPVD logout that doesn't redirect; scope needs to be manually cleared to avoid displaying previously logged in info
                $scope.loginInfo.username = "";
                $scope.loginInfo.password = "";
                if ((window.location.href.indexOf("/find-a-doctor/") != -1) && (session.data.basicInfo.role == "BA" || session.data.basicInfo.role == "SBA")) {
                    session.logout();
                }
                else {
                    session.logoutWithRedirect();
                }
            };
            $scope.isEmaterials = session.isEmaterials();


            $scope.login = function () {
                if ($scope.loginForm.$valid) {
                    $scope.loggingIn = true;
                    $scope.showInvalidUserPass = false;
                    $scope.showAlertIcon = true;
                    services.rbsmbl.loginversion().fetch($scope.loginInfo.username).then(function (response) {
                        if (response && response.data && response.data.payload) {
                            if (response.data.payload.loginVersion == 'MER_LOGIN_V1') {
                                services.rbsmbl.login().loginWithRedirect($scope.loginInfo.username, response.data.payload.convertCase ? $scope.loginInfo.password.toUpperCase() : $scope.loginInfo.password, null, null, true).then(function (response) {
                                    if ($window.location.href.search(/medicare.*\./) > -1) {
                                        // Don't redirect us, you are forcing a page refresh on our application, which is already slow and painful.
                                        // This logic should go in a hook in the future, so that applications can control who gets redirected.
                                        // This if statement is intentionally blank.
                                        // ~Sincerely, From everyone at the Sales Portal MEDWEB team. 
                                    } else if (response.data.payload.loginInfo.userInfo.brand == "MINCR") {
                                        $window.location.href = "/member/home";
                                    } else {
                                        $window.location.href = "/mbr/#!/landing";
                                    }
                                    coremetricsConversionTracker.finish('LOGIN', 'LOGIN');
                                    // Yay
                                    $scope.loggingIn = false;
                                }, function (error) {
                                    $scope.loginInfo.username = "";
                                    $scope.loginInfo.password = "";
                                    $scope.loggingIn = false;
                                    $scope.loginErrorContent = error.specificErrorContent;

                                    // If the error wasn't just due to a wrong user/pass combo
                                    $scope.showLoginBox = $scope.showMobileLoginBox = false;
                                    $scope.showLoginMessage = true;

                                    // If error was simply due to wrong username or password, hide the loginMessageBox and display the error inside the login form
                                    if (error.data && error.data.baseMessage) {
                                        switch (error.data.baseMessage.returnCodeDescription) {
                                            case "GEN-NORECCHMECS":
                                            case "GEN-NOMATCH":
                                            case "USER-NOT-ON-FILE":
                                                $scope.showLoginBox = $scope.showMobileLoginBox = true;
                                                $scope.showInvalidUserPass = true;
                                                $scope.showLoginMessage = false;
                                                break;
                                            case "GEN-NOTONPLATFORM":
                                                $scope.showAlertIcon = false;
                                                break;
                                        }
                                    }
                                });
                            } else if (response.data.payload.loginVersion === 'BV_LOGIN') {
                                //Used for session storage retrival. Any cookies left from prior sessions being cleaned up
                                $cookies.remove('producerId');
                                if (response.data.payload.convertCase === true) {
                                    $scope.loginInfo.username = $scope.loginInfo.username.toUpperCase();
                                    $scope.loginInfo.password = $scope.loginInfo.password.toUpperCase();
                                }
                                //This gets triggered only for *.highmarkbcbs.com, *.highmarkbcbsde.com, *.highmarkbcbswv.com, *.highmarkblueshield.com find-a-doctor page
                                //adjust logic here if thats not the case
                                $scope.loggingIn = false;

                                $scope.loginErrorContent = {
                                    "blockTitle": "INVALID LOGIN ATTEMPT",
                                    "blockText":"You are not authorized to login to this site."
                                };
                                $scope.showLoginBox =false;
                                $scope.showLoginMessage = true;

                            }
                            else {
                                $scope.loggingIn = false;
                            }
                        }
                        else {
                            // TODO FIXME handle error gracefully
                            $scope.loggingIn = false;
                        }
                    }, function (/*error*/) {
                        // TODO FIXME handle error
                        $scope.loggingIn = false;
                    });
                }
            };

            $scope.fontSize = function (size) {
                var fontSizes = ['bodyFontSmall', 'bodyFontLarge', 'bodyFontLargest'];
                angular.element(document.body).removeClass(fontSizes.join(' '));
                angular.element(document.body).addClass(fontSizes[size]);
                var fontSize = '';
                switch (size) {
                    case 0:
                        fontSize = 'SMALL';
                        break;
                    case 1:
                        fontSize = 'MEDIUM';
                        break;
                    case 2:
                        fontSize = 'LARGE';
                        break;
                }
                coremetrics.elementTag(fontSize, 'FONT SIZE');
            };
            angular.element(document.body).addClass('bodyFontSmall');
            $scope.languageModal = function (id) {
                var title, body;
                title = body = '';
                if (id === 'language_all') {
                    title = 'Additional Languages';
                    for (var lang in $scope.languages) {
                        body = body + '<section><strong class="h4">' + $scope.languages[lang].titleHTMLUnicode + '</strong>' + $scope.languages[lang].messageHTMLUnicode + '</section>';
                    }
                }
                else {
                    title = $scope.languages[id].titleHTMLUnicode;
                    body = $scope.languages[id].messageHTMLUnicode;
                }
                var coremetricsLanguage;
                switch (id) {
                    case 'language_spanish':
                        coremetricsLanguage = 'ESPANOL';
                        break;
                    case 'language_vietnamese':
                        coremetricsLanguage = 'VIETNAMESE';
                        break;
                    case 'language_russian':
                        coremetricsLanguage = 'RUSSIAN';
                        break;
                    case 'language_italian':
                        coremetricsLanguage = 'ITALIANO';
                        break;
                    case 'language_trad_chinese':
                        coremetricsLanguage = 'CHINESE';
                        break;
                    case 'language_all':
                        coremetricsLanguage = 'OTHER';
                        break;
                }
                coremetrics.elementTag(coremetricsLanguage, 'LANGUAGE');
                modal.open({
                    heading: title,
                    template: body,
                    controller: ["$scope", "brand", function ($scope, brand) {

                        switch (brand.current.sharedBrandCode) {
                            case "fl":
                            case "mn":
                            case "pp":
                            case "az":
                            case "la":
                            case "exc":
                            case "lou":
                            case "neb":
                            case "regbcbs":
                            case "regbs":
                            case "inac":
                            case "hz":
                            case "wi":
                            case "idh":
                                $scope.mbh = true;
                                break;
                            default:
                                $scope.mbh = false;
                                break;
                        }
                        if ($scope.brandData.phoneNumbers) {
                            $scope.CSPhoneNumber = '';
                            $scope.languageNonMedicare = $scope.brandData.phoneNumbers.languageNonMedicare.join(' / ');
                            $scope.languageMedicare = $scope.brandData.phoneNumbers.languageMedicare.join(' / ');
                            $scope.languageEmployer = $scope.brandData.phoneNumbers.languageEmployer.join(' / ');
                        }

                    }]
                });
                // new Modal('<div class="content-column"><strong class="h3 no-mobile no-tablet">' + title + '</strong><hr class="thick no-mobile no-tablet"><div class="margin-top"><div class="language-other-scroll">' + body + '</div></div></div>');
            };

            $scope.forgotCoremetrics = function () {
                coremetrics.elementTag('FORGOT: USERNAME OR PASSWORD', 'FORGOT');
            };
            $scope.ContactUsCoremetrics = function () {

                // Please don't keep extending this if you need custom contactUs. You need to make this a configurable value that can be set on a project level.
                var contactUsUrl = appId.toLowerCase() === 'medweb' ? brand.current.contactUs : "/msg/#!/contact-us";

                window.location = contactUsUrl;
                coremetrics.elementTag('CONTACT US', 'NEED HELP: CONTACT US');
            };
            $scope.needHelpCoremetrics = function () {
                if (!needHelpCoremtricsFlag) {
                    coremetrics.elementTag('NEED HELP', 'NEED HELP');
                    needHelpCoremtricsFlag = true;
                }
            };
            $scope.helpMobile = function () {

                if ($scope.isWYBCBSSNR) {
                    modal.open({
                        scope: $scope,
                        template: '<article class="headerNeedHelpMobile">' +
                            '<section>' +
                            '<h1>QUESTIONS?</h1>' +
                            '<p>' +
                            'We\'re here to help.<br />' +
                            'Monday-Friday 8 a.m. - 5 p.m.<br />' +
                            '<span data-ng-if="[\'AGENT\', \'AGENCY_ADMIN\', \'INTERNAL\'].indexOf(session.basicInfo.role) === -1">800-851-2227</span>' +
                            '<span data-ng-if="[\'AGENT\', \'AGENCY_ADMIN\', \'INTERNAL\'].indexOf(session.basicInfo.role) !== -1">800-442-2376</span><br/>' +
                            '<a href="mailto:medicare@bcbswy.com" data-ng-if="[\'AGENT\', \'AGENCY_ADMIN\', \'INTERNAL\'].indexOf(session.basicInfo.role) === -1">Medicare@bcbswy.com</a>' +
                            '<a href="mailto:sales.support@bcbswy.com" data-ng-if="[\'AGENT\', \'AGENCY_ADMIN\', \'INTERNAL\'].indexOf(session.basicInfo.role) !== -1">Sales.Support@bcbswy.com</a><br/>' +
                            'TTY:711' +
                            '</p>' +
                            '</section>' +
                            '</article>'
                    });
                } else {
                    modal.open({
                        scope: $scope,
                        template: '<article class="headerNeedHelpMobile">' +
                            '<section>' +
                            '<h1>Call</h1>' +
                            '<img src="/bootstrap/v4/resources/img/icons/CallIcon32px.png" alt="">' +
                            '<p>Have questions about benefits or claims? Or need support in your language? Please call the number on the back of your member ID card.</p>' +
                            '<p data-ng-if="brandData.phoneNumbers.languageDisability" class="margin-top">We provide free accommodations for those with disabilities.' +
                            '<span data-ng-if="brandData.phoneNumbers.languageDisablityText" >For help call  {{brandData.phoneNumbers.languageDisability}} and give the operator the number on the back of your member ID card.</span>' +
                            '<span data-ng-if="brandData.phoneNumbers.languageDisability && !brandData.phoneNumbers.languageDisablityText">TTY users call   {{brandData.phoneNumbers.languageDisability}}</span>' +
                            '<span data-ng-if="brandData.phoneNumbers.TTY && !brandData.phoneNumbers.languageDisablityText" class="margin-top"> or dial {{brandData.phoneNumbers.TTY}}.</span></p>' +
                            '<p data-ng-if="brandData.phoneNumbers.languageDisablityText" >TTY users dial {{brandData.phoneNumbers.TTY}}.</p>' +
                            '<p data-ng-if="brandData.phoneNumbers.technical" class="margin-top">If you have a technical question about this website, please call <br /> {{brandData.phoneNumbers.technical}}.</p>' +
                            '</section>' +
                            '<section data-ng-if="!session.tempPassword && session.loggedIn">' +
                            '<h1>Click</h1>' +
                            '<img data-ng-src="/bootstrap/v4/resources/img/icons/ClickIcon32px.png" alt="">' +
                            '<p>If you have any questions or concerns, please feel free to <a href="/msg/#!/contact-us">Contact Us</a> and we will get back to you soon.</p>' +
                            '</section>' +
                            '</article>'
                    });
                }
            };
            var headerTabGlow = function (state) {
                $scope.selectedTabText = '';
                if (state && $scope.navigation) {
                    for (var i in $scope.navigation.headerTabs) {
                        if ($scope.navigation.headerTabs[i].rootState === state.name.split('.')[0]) {
                            $scope.navigation.headerTabs[i].active = true;
                            $scope.selectedTabText = $scope.navigation.headerTabs[i].label;
                        }
                        else {
                            $scope.navigation.headerTabs[i].active = false;
                        }
                    }
                }
                if (state && state.data && state.data.headerText) {
                    $scope.selectedTabText = state.data.headerText;
                }
            };
            $scope.brandData = brand.current;
            $scope.navigation = navigation.data;
            $scope.hasMessageCenter = (typeof $scope.brandData.messageCenter !== "undefined") ? $scope.brandData.messageCenter : true;
            $scope.$watchCollection('navigation', function () {
                headerTabGlow($state.current);
            });
            $scope.session = session.data;

            //smart message section check
            //$scope.smartMessage = (brand.current.sharedBrandCode.toLowerCase() == 'mincr') ? true : false;

            $scope.$watch('session.loggedIn', function () {
                // reset scoped variables that can change during login/logout to their default values
                $scope.allowNeedHelp = true;
                $scope.isDeepLinkIdCard = window.location.hash.search('idCard') > 1;
                $scope.msgCenterDeepLink = window.location.hash.search('msgCenter') > 1;
                if($scope.isDeepLinkIdCard || $scope.msgCenterDeepLink) {
                    $scope.navigation.headerTabs = [];
                }

                $scope.shouldShowLanguagesHeader = $scope.isWYBCBS || $scope.isNDBCBS ? true : taglines.shouldShowLanguages($scope.session.appConfig, $scope.showLanguages);
                if ($scope.shouldShowLanguagesHeader) {
                    populateHeaderLanguagesMenu();
                }

                if ($scope.session.loggedIn) {

                        //Avaya chat POST PASSWORD CONTROL LOGIC WITH CIS INDICATOR
                    if(sessionData.appConfig.MEMBER &&
                        sessionData.appConfig.MEMBER.USE_AVAYA_INDICATOR &&
                        sessionData.appConfig.MEMBER.USE_AVAYA_INDICATOR.booleanValue == true) {
                        $scope.showClickToChat = false;
                        var selectedGroup = $cookies.get("mbrGroupNumber");
                        var selectedClient = $cookies.get("mbrClientNumber");
                        for (var i = 0; i < session.data.memberInfo.clientList.length; i++) {
                            var client = session.data.memberInfo.clientList[i];
                            if (client.clientNumber === selectedClient) {
                                for (var j = 0; j < client.groupList.length; j++) {
                                    var groupList = client.groupList[j];
                                    if (groupList.groupNumber === selectedGroup) {
                                        $scope.showClickToChat = true;
                                        $scope.toggle = "live";
                                        for (var k = 0; k < groupList.optOutList.length; k++) {
                                            var optOutListInfo = groupList.optOutList[k];
                                            if (optOutListInfo.code === "905") {
                                                $scope.showClickToChat = false;
                                                break;
                                            }
                                        }
                                    }

                                }
                            }
                        }
                    }

                    // // Post Password Header
                    if (session.data.basicInfo) {
                        if (session.data.basicInfo.role && session.data.basicInfo.role.toLowerCase) {
                            if (~["ba", "bacancelled","mcu_admin"].indexOf(session.data.basicInfo.role.toLowerCase())) {
                                $scope.shouldShowLanguagesHeader = false;
                                $scope.allowNeedHelp = false;
                            }
                        }
                        //redirecting telesales users to Producer
                        if (["telesales", "agent", "agency_admin", "internal"].indexOf(session.data.basicInfo.role.toLowerCase()) > -1) {
                            if (session.data.basicInfo.temporaryPasswordFlag) {
                                window.location.href = 'https://' + window.location.hostname.replace("medicare", "producer");
                            }
                        }

                        $scope.friendlyName = session.data.basicInfo.firstName.toLowerCase();
                        if ($scope.hasMessageCenter && session.data.memberInfo) {
                            services.rbsmbl.countUnreadMessages().fetch(session.data.memberInfo).then(function (response) {
                                if (response && response.data && response.data.payload && response.data.payload[0]) {
                                    $scope.unreadMessagesCount = response.data.payload[0].unreadMessagesCount;
                                }
                            });
                        }
                        var portalSelectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan(session.data.memberInfo);

                        if($scope.isNDBCBS && portalSelectedPlan && portalSelectedPlan.isNDMedicaid){
                            $scope.brandData.phoneNumbers.technical = "1-833-777-5779";
                            $scope.nonDiscriminationND= true;
                        }
                        var teamsiteLinkId = $scope.nonDiscriminationND ? MBR_MEANINGFUL_ACCESS_LINK_BTS3_NDMEDICAID_ID : MBR_MEANINGFUL_ACCESS_LINK_ID;    
                        // Get the URL for the meaningful-access page from teamsite.
                        teamsite.get(teamsiteLinkId).then(
                            function (response) {
                                var languageLink = JSON.parse(response);
                                $scope.meaningfulAccessURL = languageLink.href;
                            }, function (/*error*/) {
                        });

                        // if ($scope.hasMessageCenter && session.data.memberInfo) {
                        //     services.rbsmbl.csPhoneNumber().fetch(session.data.memberInfo).then(function (response) {
                        //         if (response && response.data && response.data.payload) {

                        //             var CSPhoneNumber = response.data.payload.CSPhoneNumber;

                        //             if (CSPhoneNumber && CSPhoneNumber.replace(/\s/g, '').length > 0) {
                        //                 var lastFour, middleThree, areaCode, international, len;
                        //                 len = CSPhoneNumber.length;

                        //                 lastFour = CSPhoneNumber.substring(len - 4, len);
                        //                 middleThree = CSPhoneNumber.substring(len - 7, len - 4);
                        //                 areaCode = CSPhoneNumber.substring(len - 10, len - 7);
                        //                 international = (len == 11) ? CSPhoneNumber.substring(len - 11, len - 10) + '-' : '';
                        //                 CSPhoneNumber = international + areaCode + '-' + middleThree + '-' + lastFour;
                        //                 $scope.CSPhoneNumber = '';
                        //                 $scope.CSPhoneNumber = CSPhoneNumber;
                        //             }
                        //         }
                        //     });
                        // }
                        // TODO: is the line below still necessary?
                        headerTabGlow($state.current); // TODO: is this exact line of code still necessary?
                        // TODO: is the line above still necessary?
                    }
                    if (session.isEmaterials()) {
                        $scope.allowNeedHelp = false;
                    }
                }
            });

            $scope.disableClickToChat = false;


                    clickToChat.disableClickToChat().then(
                        function (response) {
                            $scope.disableClickToChat = response;
                        },
                        function (response) {
                            //console.log(response);
                        }
                    );

            $scope.clickToChat = function () {
                if($scope.showClickToChat || $scope.preLoginChat){
                    $scope.showNeedHelp = false;
                    var x = document.getElementsByClassName("stickyLiveChat");
                    x[0].style.display = "none";
                }else{
                    clickToChat.openClickToChat();
                }
            };

            $scope.windowLocation = function (url) {
                window.location = url;
            };

            $scope.$on('$stateChangeSuccess', function (event, toState/*, toParams, fromState, fromParams*/) {
                $scope.navopen = false;
                headerTabGlow(toState);
            });
        }]);
};
